import { useCallback } from "react";
import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";

/**
 * Hook that returns a stable function to open a confirm modal with a consistent design.
 *
 * @returns {(options: {
 *   title: string,
 *   message: string,
 *   onConfirm: function,
 *   confirmLabel?: string,
 *   cancelLabel?: string,
 *   confirmColor?: string,
 * }) => void}
 *
 * @example
 * const confirm = useConfirm();
 * confirm({
 *   title: "Remove user?",
 *   message: "Are you sure you want to remove this user?",
 *   confirmLabel: "Remove",
 *   onConfirm: () => mutate({ userId }),
 * });
 */
export function useConfirm() {
  return useCallback(
    ({
      title,
      message,
      onConfirm,
      confirmLabel = "Confirm",
      cancelLabel = "Cancel",
      confirmColor,
    }) => {
      modals.openConfirmModal({
        title,
        centered: true,
        children: <Text size="sm">{message}</Text>,
        labels: { confirm: confirmLabel, cancel: cancelLabel },
        confirmProps: confirmColor ? { color: confirmColor } : undefined,
        onConfirm,
      });
    },
    []
  );
}
